import { render, staticRenderFns } from "./NavItemAddIcon.vue?vue&type=template&id=9caa5e08&"
import script from "./NavItemAddIcon.vue?vue&type=script&lang=js&"
export * from "./NavItemAddIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavItemAddIcon.vue?vue&type=style&index=0&id=9caa5e08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports